




















































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Enums
import { DataModules } from "@/store/modules/data";

// types
import { IBrand, IBrandTaxSettingsForm } from "@/models/brands";
import { IState } from "@/store";

@Component({
  computed: {
    ...mapState({
      brand(state: IState) {
        return state.brand;
      }
    })
  }
})
export default class BrandTaxSettings extends Mixins(HasValidation) {
  // Getters
  public brand!: IBrand;

  @Prop({ required: true })
  public isProcessing!: boolean;

  @Prop({ default: false })
  public dynamicSettingsLoading!: boolean;

  public form = {
    vat_number: "",
    vat_exempt: 0,
    tax_type: 0
  } as IBrandTaxSettingsForm;
  public formClone = this.$_.clone(this.form);

  public dataModule: string = DataModules.BRANDS;

  public isLoading = true;

  public vatRegistered = 0;
  public prevVatNumber = "";

  public async created() {
    this.fillForm();
    this.isLoading = false;
  }

  public fillForm() {
    this.form = (this.$_.pick(
      this.$_.merge({}, this.form, this.brand),
      this.$_.intersection(
        this.$_.keys(this.$_.merge({}, this.form, this.brand)),
        this.$_.keys(this.form)
      )
    ) as any) as IBrandTaxSettingsForm;
    this.formClone = this.$_.cloneDeep(this.form);
    this.prevVatNumber = this.form.vat_number;
  }

  public get formIsValid() {
    if (this.$_.isEqual(this.form, this.formClone)) {
      return false;
    }
    return true;
  }

  public get formIsDisabled() {
    return this.isProcessing || !this.formIsValid || this.hasErrors;
  }

  public save() {
    return new Promise((resolve, reject) => {
      this.updateBrand()
        .then(async () => {
          this.formClone = this.$_.cloneDeep(this.form);
          this.$emit("predefinedSettingsAreChanged", false);
          await this.refreshBrand();
          resolve(true);
        })
        .catch(error => {
          this.$store.dispatch("api/handleValidationError", {
            error,
            vm: this,
            showToast: false
          });
          reject(error);
        });
    });
  }

  public revertToInitialState() {
    this.fillForm();
  }

  public refreshBrand() {
    return this.$store.dispatch("brand/get", { ignoreStored: true });
  }

  public updateBrand() {
    return this.$store.dispatch(`data/${this.dataModule}/update`, {
      id: this.$_.get(this.brand, "id"),
      data: this.getNewValues()
    });
  }

  public getNewValues() {
    const newValues: any = this.$_.omitBy(this.form, (v, k) => {
      return this.formClone[k] === v;
    });

    return newValues;
  }

  public onVatRegisteredChange(vatRegistered: number) {
    if (vatRegistered) {
      this.form.vat_number = "";
    } else {
      this.form.vat_number = this.prevVatNumber;
    }
  }

  public get formIsChanged() {
    return !this.$_.isEqual(this.form, this.formClone);
  }

  @Watch("formIsChanged")
  public onFormIsChanged(isChanged) {
    this.$emit("predefinedSettingsAreChanged", isChanged);
  }

  @Watch("isLoading", { immediate: true })
  public onIsLoadingChange() {
    this.$emit("predefinedSettingsAreLoading", this.isLoading);
  }
}
